/**
 * Pattern to validate an amount
 *
 * This pattern can check for up to 8 digits and 2 decimal places if they are provided
 * Decimal places are optional unless a cent separator is given, from which the
 * decimal places become mandatory
 *
 * @example
 *
 * ```ts
 * amountInputValidationRegex.test('1') // true
 * amountInputValidationRegex.test('12') // true
 * amountInputValidationRegex.test('123') // true
 * amountInputValidationRegex.test('1.23') // true
 * amountInputValidationRegex.test('12.34') // true
 * amountInputValidationRegex.test('123.45') // true
 * amountInputValidationRegex.test('123.') // false
 * amountInputValidationRegex.test('123456789') // false
 * amountInputValidationRegex.test('123.1') // false
 * amountInputValidationRegex.test('$123') // false
 * amountInputValidationRegex.test('🦎') // false
 * amountInputValidationRegex.test('🍺') // false
 * ```
 */
export const amountInputValidationRegex = /^\d{1,8}(?:\.\d{2})?$/

export const NUMERIC_REGEX = /[^0-9]/g

/**
 * Validates an email address against RFC 5321 (local part), RFC 1035 (domain),
 * and WHATWG HTML5 email rules.
 *
 * Valid examples:
 *   user@example.com
 *   user.name@example.com
 *   user+tag@example.com
 *   user_name@example.com
 *   user123@sub.domain.com.au
 *   user!name@example.org
 *   user#name@example.net
 *
 * Invalid examples:
 *   user;name@example.com   — semicolons not allowed
 *   user @example.com       — spaces not allowed
 *   user@                   — missing domain
 *   @example.com            — missing local part
 *   user@example            — missing TLD
 *   user@-example.com       — domain label cannot start with hyphen
 *   user@example-.com       — domain label cannot end with hyphen
 *   user@@example.com       — double @ not allowed
 *   (empty string)          — required field
 */
export function isEmailValid(email: string) {
  const emailValidation =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/
  return emailValidation.test(email)
}

export function isMobileValid(phone: string) {
  const phoneValidation = /^04\d{8}$/
  return phoneValidation.test(phone)
}
